import angular from 'angular';

// filter to convert html to plain text
export const loadModule = () =>
  angular.module('app').filter('capitalize', function capitalize() {
    return function (text) {
      return String(text).charAt(0).toUpperCase + String(text).splice(1);
    };
  });
